import axios from 'axios'
import url from '@/urls'

export default {
  GET_INN_INFO({ commit }, inn) {
    commit('LOADING_BTN', true)
    return axios({
      url: `${url.GET_INN_INFO}${inn}`,
      method: 'GET'
    })
      .then(response => {
        commit('GET_INN_INFO_SUCCESS', response.data)
        commit('LOADING_BTN', false)
      })
      .catch(error => {
        commit('GET_INN_INFO_ERROR', error.response.data.message)
        commit('LOADING_BTN', false)
      })
  },
  CHECK_INN({ commit }, data) {
    commit('CHECK_INN_LOADING', true)
    return axios({
      url: url.CHECK_INN_URL,
      method: 'post',
      data
    })
      .then(response => {
        commit('CHECK_INN_SUCCESS', response.data)
        commit('CHECK_INN_LOADING', false)
      })
      .catch(error => {
        commit('CHECK_INN_ERROR', error.response.data.message)
        commit('CHECK_INN_LOADING', false)
      })
  },
  CHECK_PERSONAL_INN({ commit, state }, data) {
    data.innOrganisation = state.checkInnResponse.inn
    commit('CHECK_PERSONAL_INN_LOADING', true)
    return axios({
      url: url.CHECK_BOTH_INN_URL,
      method: 'post',
      data: data
    })
      .then(response => {
        commit('CHECK_PERSONAL_INN_SUCCESS', response.data)
        commit('CHECK_PERSONAL_INN_LOADING', false)
      })
      .catch(error => {
        if (error.response) {
          commit('CHECK_PERSONAL_INN_ERROR', error.response.data.message)
          commit('CHECK_PERSONAL_INN_LOADING', false)
        }
      })
  },
  GET_TOKEN({ commit, state, dispatch }, data) {
    let confirmRequest = (URL, payload) => {
      axios({
        url: URL,
        method: 'post',
        data: payload
      })
        .then(response => {
          commit('GET_TOKEN_SUCCESS', response.data)
          dispatch('GET_USER_NAME')
          dispatch('SHOW_BACK_BTN', false)
          commit('PIN_CONFIRM_LOADING', false)
        })
        .catch(error => {
          commit('GET_TOKEN_ERROR', error.response.data)
          commit('PIN_CONFIRM_LOADING', false)
        })
    }

    commit('PIN_CONFIRM_LOADING', true)
    if (state.checkPersonalInnResponse.length !== 0) {
      data.innOrganisation = state.checkPersonalInnResponse.innOrganisation
      data.innEmployee = state.checkPersonalInnResponse.innEmployee
      confirmRequest(url.GET_EMPLOYEE_TOKEN_URL, data)
    } else {
      data.inn = state.checkInnResponse.inn
      confirmRequest(url.GET_TOKEN_URL, data)
    }
  },
  SHOW_BACK_BTN({ commit }, data) {
    commit('SET_SHOW_BACK_BTN', data)
  },
  AUTH_WITH_SMART_ID({ commit }, sessionId) {
    axios({
      method: 'POST',
      url: `/api/Auth/employee/AuthorizationBySessionServer/${sessionId}`
    })
      .then(response => {
        commit('GET_TOKEN_SUCCESS', response.data)
      })
      .catch(error => {
        commit('GET_TOKEN_ERROR', error.response.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/actions.js